/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import DataTableComponent, { ColumnOption } from "../../../common/DataTable";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import { InputText } from "primereact/inputtext";
import { EditButtonSVG } from "../../../../assets/SVGs/EditButtonSVG";
import { TableSortingSVG } from "../../../../assets/SVGs/TableSortingSVG";
import { Dialog } from "primereact/dialog";
import { DeleteIconSVG } from "../../../../assets/SVGs/DeleteIconSVG";
import { ConfirmDialog } from "primereact/confirmdialog";
import { DeletePopupTrashIcon } from "../../../../assets/SVGs/DeletePopupTrashIcon";
import { Calendar } from "primereact/calendar";
import axios from "../../../../util/axiosconfig";
import { SORT_FILTER } from "../../../../util/constants";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { showError } from "../../../../util/ShowStatus";
import { MultiSelect } from "primereact/multiselect";
import {
  convertDateToEpoch,
  convertEpochtoDate,
  convertUTCEpochToDate,
  fetchDayFromEpochDate,
} from "../../../../helper/DateConverters";
import { ROLES } from "../../../../util/roleNameConstants";

interface Holiday {
  holidayID?: string | null;
  startDay: string | null; // changed
  endDay: string | null; // changed
  startDate: any;
  endDate: any;
  name: string | null;
  departments: any;
  isActive: boolean;
}

interface FormErrors {
  day: string | null;
  startDate: string | null;
  endDate: string | null;
  name: string | null;
  departments: any;
}

const HolidaysManagement = () => {
  const [holidaysLoading, setHolidaysLoading] = useState<boolean>(false);
  const [isDialogVisible, setIsDialogVisible] = useState<boolean>(false);
  const [formType, setFormType] = useState<string>("add");
  const [isConfirmDeleteDialogOpen, setIsConfirmDeleteDialogOpen] =
    useState<boolean>(false);
  const [deleteReason, setDeleteReason] = useState<string>("");
  const [deleteReasonError, setDeleteReasonError] = useState<string | null>(
    null
  );
  const page = 0;
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(false);
  const [departments, setDepartments] = useState<any[]>([]);
  const [deleteId, setDeleteId] = useState<string | null | undefined>(null);
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [isExporting, setIsExporting] = useState<boolean>(false);

  const [formValues, setFormValues] = useState<Holiday>({
    startDay: null, // changed
    endDay: null, // changed
    startDate: null,
    endDate: null,
    name: null,
    departments: null,
    isActive: true,
  });

  const [formErrors, setFormErrors] = useState<FormErrors>({
    day: null,
    startDate: null,
    endDate: null,
    name: null,
    departments: null,
  });

  const [sortFilter, setSortFilter] = useState<any>({
    sortField: "createdDate",
    sortOrder: false,
  });

  const fetchHolidays = async (page: number, size: number, type?: string) => {
    setHolidaysLoading(true);
    try {
      // Fetch holidays
      const params: any = {
        size,
        page,
        sortField: sortFilter.sortField,
        sortOrder:
          sortFilter.sortOrder === true ? SORT_FILTER.ASC : SORT_FILTER.DESC,
      };
      // const response = await axios.get("tl-admin/holiday/all", { params });
      // setHolidays(response.data.result);
      if (type === "export") {
        try {
          setIsExporting(true);
          const response = await axios.get("tl-admin/export-holiday", {
            params,
            responseType: "blob", // Important for binary data
          });

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.download = "holiday_report.csv";

          // Append to body and trigger download
          document.body.appendChild(link);
          link.click();

          // Clean up
          link.parentNode?.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {}
      } else {
        setHolidaysLoading(true);
        const response = await axios.get("tl-admin/holiday/all", { params });
        setHolidays(response.data.result);
        setTotalRecords(response.data.totalRecords); // Assuming the API returns the total count
      }
      setIsExporting(false);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
    } finally {
      setHolidaysLoading(false);
    }
  };

  const fetchDepartments = async () => {
    try {
      // Fetch departments
      const response = await axios.get("tl-admin/department/all?page=-1");
      setDepartments(
        response.data.result.map((department: any) => ({
          departmentName: department.name,
          departmentID: department.departmentID,
        }))
      );
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  useEffect(() => {
    setFirst(page);
    fetchHolidays(page, size);
    // fetchDepartments();
  }, [sortFilter]);

  const [first, setFirst] = useState<number>(0);
  const [size, setSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(10); // To hold the total number of records
  const [selectedDates, setSelectedDates] = useState<any>([]); // To hold selected dates for the date range picker

  const toast = useRef<Toast>(null);

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setFirst(event.first);
    setSize(event.rows); // Set the number of rows per page
    const currentPage = Math.floor(event.first / event.rows); // Calculate the current page index
    fetchHolidays(currentPage, event.rows);
  };
  const headerTemplate = (header: string, field: string) => {
    return (
      <div
        className={`tw-flex tw-justify-between tw-w-full tw-items-center ${
          field !== "" && "tw-cursor-pointer"
        }`}
        onClick={() => {
          if (field !== "") {
            setSortFilter((prevSortFilter: any) => ({
              ...prevSortFilter,
              sortField: field,
              sortOrder: !prevSortFilter.sortOrder,
            }));
          }
        }}
      >
        <span className="tw-font-bold">{header}</span>
        {field !== "" && (
          <span className="tw-ml-4 tw-mr-0">
            <TableSortingSVG />
          </span>
        )}
      </div>
    );
  };

  const validateForm = (type?: string) => {
    const errors: Partial<Record<string, string>> = {};

    if (!formValues.startDate) {
      errors.startDate = "Start date is required";
    }
    if (!formValues.endDate) {
      errors.endDate = "End date is required";
    }
    if (!formValues.name || formValues.name.trim() === "") {
      errors.name = "Name is required";
    }
    if (!formValues.departments || formValues.departments.length === 0) {
      errors.departments = "Department(s) name is required";
    }
    setFormErrors((prev) => ({ ...prev, ...errors }));

    return Object.keys(errors).length === 0; // Returns true if no errors
  };

  const handleAddUpdateHoliday = async () => {
    if (!validateForm()) return; // Stop submission if validation fails
    try {
      setIsAddButtonDisabled(true);
      const holidayData: any = {};
      if (formType === "update") {
        holidayData.holidayID = formValues.holidayID;
      }
      holidayData.name = formValues.name;
      holidayData.startDay = formValues.startDay; // changed
      holidayData.endDay = formValues.endDay; // changed
      holidayData.startDate = formValues.startDate;
      holidayData.endDate = formValues.endDate;
      holidayData.departments = formValues.departments.map(
        (department: any) => department.departmentID
      );

      formType === "add"
        ? await axios.post("tl-admin/add-holiday", holidayData)
        : await axios.post("tl-admin/edit-holiday", holidayData);
      setIsDialogVisible(false);
      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        startDate: null,
        endDate: null,
        startDay: null, // changed
        endDay: null, // changed
        name: null,
        departments: null,
      }));
      setSelectedDates([]);
      setIsAddButtonDisabled(false);
      setFirst(page);
      fetchHolidays(page, size);
    } catch (err) {
      const error = getErrorMessage(err);
      setIsAddButtonDisabled(false);
      showError(error, toast);
    }
  };

  const handleEditHoliday = (rowData: Holiday) => {
    setFormType("update");
    setFormValues(rowData);
    setSelectedDates([
      new Date(rowData.startDate * 1000),
      new Date(rowData.endDate * 1000),
    ]);
    setIsDialogVisible(true);
  };

  const departmentTemplate = (rowData: Holiday) => {
    return (
      <div className="tw-flex tw-flex-wrap">
        {rowData.departments.map((department: any, index: number) => {
          return (
            <span key={index} className={index % 3 !== 2 ? "tw-mr-0" : ""}>
              {department.departmentName}
              {index !== rowData.departments.length - 1 ? `,` : ""}&nbsp;
            </span>
          );
        })}
      </div>
    );
  };

  const actionBodyTemplate = (rowData: Holiday) => (
    <div className="tw-flex tw-gap-4">
      <Button
        className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto focus:tw-shadow-none"
        onClick={() => handleEditHoliday(rowData)}
      >
        <EditButtonSVG />
      </Button>
      <Button
        className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto focus:tw-shadow-none"
        onClick={() => {
          setDeleteId(rowData.holidayID);
          setIsConfirmDeleteDialogOpen(true);
        }}
      >
        <DeleteIconSVG />
      </Button>
    </div>
  );

  const startDateTemplate = (rowData: any) => (
    <div className="tw-flex tw-gap-4">
      <span>{convertEpochtoDate(rowData.startDate)},</span>
      <span>{fetchDayFromEpochDate(rowData.startDate)}</span>
    </div>
  );

  const endDateTemplate = (rowData: any) => (
    <div className="tw-flex tw-gap-4">
      <span>{convertEpochtoDate(rowData.endDate)},</span>
      <span>{fetchDayFromEpochDate(rowData.endDate)}</span>
    </div>
  );

  const holidaysColumns: ColumnOption[] = [
    {
      field: "startDate",
      header: headerTemplate("Start Date", "startDate"),
      body: startDateTemplate,
      visible: true,
    },
    {
      field: "endDate",
      header: headerTemplate("End Date", "endDate"),
      body: endDateTemplate,
      visible: true,
    },
    {
      field: "name",
      header: headerTemplate("Name", "name"),
      visible: true,
    },
    {
      field: "departments",
      header: headerTemplate("Department", ""),
      body: departmentTemplate,
      visible: true,
    },
  ];

  if (
    localStorage.roleName.includes(ROLES.TIMELOG_ADMIN) ||
    localStorage.roleName.includes(ROLES.SUPER_ADMIN)
  ) {
    holidaysColumns.push({
      field: "action",
      header: headerTemplate("Action", ""),
      body: actionBodyTemplate,
      visible: true,
    });
  }

  const handleDelete = async () => {
    if (!deleteReason.trim()) {
      setDeleteReasonError("Please provide a reason for deleting this holiday");
      return;
    }
    try {
      setIsAddButtonDisabled(true);
      const params: any = {
        holidayID: deleteId,
        isActive: false,
        statusChangeReason: deleteReason,
      };
      await axios.post("tl-admin/edit-holiday", params);
      setFirst(page);
      fetchHolidays(page, size);
      setIsAddButtonDisabled(false);
      setIsConfirmDeleteDialogOpen(false);
      setDeleteReason("");
      setDeleteReasonError(null);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
      setIsAddButtonDisabled(false);
    }
  };

  const InvoiceDateConst = (dates: any[]) => {
    setSelectedDates(dates);
    if (!dates || dates.length !== 2) return;

    // Convert to UTC before getting time
    const toUTC = (d: Date | null) =>
      d
        ? new Date(
            Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0)
          )
        : null;
    const formattedStartDate = dates[0]
      ? Math.floor(toUTC(dates[0])!.getTime() / 1000.0)
      : null;
    const formattedEndDate = dates[1]
      ? Math.floor(toUTC(dates[1])!.getTime() / 1000.0)
      : null;

    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      startDay: fetchDayFromEpochDate(formattedStartDate), // changed
      endDay: fetchDayFromEpochDate(formattedEndDate), // changed
    }));
    setFormErrors((prevFormErrors: FormErrors) => ({
      ...prevFormErrors,
      startDate: null,
      endDate: null,
    }));
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="card">
        <div className="tw-flex tw-justify-between tw-items-center tw-w-full tw-gap-4 tw-bg-[#F8FAFC] tw-p-4 tw-mr-4">
          <h1 className="tw-font-bold tw-text-xl">Statutory Holidays</h1>

          {(localStorage.roleName.includes(ROLES.TIMELOG_ADMIN) ||
            localStorage.roleName.includes(ROLES.SUPER_ADMIN)) && (
            <div className="tw-flex tw-gap-2 focus:tw-shadow-none">
              <Button
                className="tw-flex tw-px-3 tw-py-2 tw-rounded bg-primary hover:tw-bg-[#02a2db] border-primary tw-text-white tw-font-medium"
                label="Add Statutory Holiday"
                icon="pi pi-plus"
                onClick={() => {
                  setFormType("add");
                  setFormValues({
                    startDay: null, // changed
                    endDay: null, // changed
                    startDate: null,
                    endDate: null,
                    name: null,
                    departments: null,
                    isActive: true,
                  });
                  setSelectedDates([]);
                  setIsDialogVisible(true);
                }}
              />
              <Button
                type="button"
                icon="pi pi-upload"
                label="Export"
                loading={isExporting}
                className="tw-flex tw-px-9 tw-py-2 tw-rounded bg-secondary border-primary hover:tw-bg-[#3f3c3c] tw-text-white tw-font-medium focus:tw-shadow-none"
                onClick={() => fetchHolidays(page, size, "export")}
              />
            </div>
          )}
        </div>
        <ConfirmDialog
          group="headless"
          visible={isConfirmDeleteDialogOpen}
          onHide={() => {
            setIsConfirmDeleteDialogOpen(false);
            setDeleteReason("");
            setDeleteReasonError(null);
          }}
          message={
            <div className="tw-flex tw-flex-col tw-w-full tw-gap-4">
              <div className="tw-flex tw-flex-align-items-center tw-w-full tw-gap-3 tw-border-bottom-1 tw-surface-border">
                <DeletePopupTrashIcon />
                <div className="tw-flex tw-flex-col">
                  <span className="tw-text-2xl tw-font-bold tw-text-black">
                    Confirmation
                  </span>
                  <span className="tw-text-lg">
                    Are you sure you want to delete this record?
                  </span>
                </div>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-2">
                <label className="tw-font-semibold">Reason for deletion</label>
                <InputText
                  value={deleteReason}
                  onChange={(e) => {
                    setDeleteReason(e.target.value);
                    setDeleteReasonError(null);
                  }}
                  placeholder="Enter reason..."
                  className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal ${
                    deleteReasonError ? "tw-border-red-500" : ""
                  }`}
                />
                {deleteReasonError && (
                  <small className="tw-text-red-500">{deleteReasonError}</small>
                )}
              </div>
            </div>
          }
          footer={() => (
            <div className="flex gap-2">
              <Button
                onClick={() => {
                  setIsConfirmDeleteDialogOpen(false);
                  setDeleteReason("");
                  setDeleteReasonError(null);
                }}
                className="tw-rounded-lg tw-border tw-border-gray-300 tw-px-4 focus:tw-shadow-none hover:tw-bg-gray-200 tw-py-2 tw-font-medium tw-transition-all tw-duration-200"
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                className="tw-bg-primary hover:tw-bg-[#152846] tw-text-white focus:tw-shadow-none tw-rounded-lg tw-px-4 tw-py-2 tw-ml-2 tw-font-medium tw-transition-all tw-duration-200"
                disabled={isAddButtonDisabled}
              >
                Delete
              </Button>
            </div>
          )}
        >
          <div className="tw-flex tw-justify-start tw-items-start tw-gap-4 tw-w-full">
            <div className="icon-wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6"
                  stroke="#9C1C21"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full">
              <h1 className="delete-title"> Confirmation</h1>
              <p className="delete-message">
                Are you sure you want to approve this leave?
              </p>
            </div>
          </div>
        </ConfirmDialog>
        <div className="card-body tw-relative tw-min-h-80 table-p-0">
          {holidaysLoading ? (
            <div className="tw-h-full tw-w-full tw-bg-white tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
              <ProgressSpinner />
            </div>
          ) : (
            <>
              <DataTableComponent
                rowData={holidays}
                columns={holidaysColumns}
                customClass="timelog-datatable"
              />

              <Paginator
                first={first}
                rows={size}
                totalRecords={totalRecords} // Set total records for pagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                onPageChange={onPageChange}
              />
            </>
          )}
        </div>
      </div>
      <Dialog
        header={
          formType === "add"
            ? "Add Statutory Holidays"
            : "Update Statutory Holidays"
        }
        visible={isDialogVisible}
        style={{ width: "20vw" }}
        onHide={() => {
          if (!isDialogVisible) return;
          setIsDialogVisible(false);
          setFormErrors((prevFormErrors) => ({
            ...prevFormErrors,
            startDate: null,
            endDate: null,
            name: null,
            departments: null,
          }));
          setFormValues((prevFormValues) => ({
            ...prevFormValues,
            startDate: null,
            endDate: null,
            startDay: null, // changed
            endDay: null, // changed
            name: null,
            departments: null,
          }));
          setSelectedDates([]);
          setFormType("add");
        }}
      >
        <div className="tw-flex tw-flex-col">
          {/* <div className="tw-mt-0 tw-flex tw-flex-col tw-gap-2">
            <label className="tw-mt-3 tw-font-bold">Date Range</label>
            <Calendar
              value={[
                getOriginalDate(formValues?.startDate) as any,
                getOriginalDate(formValues?.endDate) as any,
              ]}
              selectionMode="range"
              className={`${
                formErrors.startDate || formErrors.endDate
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              dateFormat="dd-mm-yy"
              onChange={(e) => {
                InvoiceDateConst(e.value as any[]);
              }}
              showIcon
              required
              placeholder="Select Date Range"
            />
            {(formErrors.startDate || formErrors.endDate) && (
              <p className="tw-text-red-600 tw-text-xs">
                {formErrors.startDate || formErrors.endDate}
              </p>
            )}
          </div> */}

          <div className="tw-flex tw-flex-col tw-gap-2">
            <label className="tw-font-medium">Select Date Range</label>
            <Calendar
              value={selectedDates ?? []}
              dateFormat="dd-mm-yy"
              onChange={(e) => {
                e.stopPropagation();
                setFormErrors((prev: any) => ({
                  ...prev,
                  startDate: null,
                  endDate: null,
                }));
                const selectedDates = e.value as (Date | null)[];
                InvoiceDateConst(selectedDates);
              }}
              selectionMode="range"
              disabledDays={[0, 6]} // Disable Sundays and Saturdays
              className={`${
                formErrors.startDate || formErrors.endDate
                  ? "tw-border-red-600"
                  : "tw-border-gray-400"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              placeholder="Select Date Range"
              showIcon
              readOnlyInput
              hideOnRangeSelection
            />
            {/* {showMaxAllowedDatesError && (
                          <p className="tw-text-red-600 tw-text-sm tw-mt-1">
                            {formErrors?.totalLeaveDays}
                          </p>
                        )} */}
          </div>

          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            <label className="tw-mt-3 tw-font-bold">Name</label>
            <InputText
              value={formValues?.name ?? ""}
              className={`${
                formErrors.name ? "tw-border-red-600" : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  name: null,
                }));
                e.target.value === ""
                  ? setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      name: null,
                    }))
                  : setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      name: e.target.value,
                    }));
              }}
              placeholder="Enter Statutory Holiday Name"
            />
            {/* {formErrors.businessNumber && (
                    <p className="tw-text-red-600 tw-text-xs">
                      {formErrors.businessNumber}
                    </p>
                  )} */}
          </div>
          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            <label className="tw-mt-3 tw-font-bold">Department</label>
            <MultiSelect
              value={formValues?.departments || []}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  departments: null,
                }));
                setFormValues((prevFormValues) => ({
                  ...prevFormValues,
                  departments: e.value,
                }));
              }}
              showSelectAll
              selectAllLabel="Select All"
              maxSelectedLabels={2}
              options={departments}
              optionLabel="departmentName"
              placeholder="Select Department"
              className={`tw-border tw-border-solid ${
                formErrors.departments
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal tw-w-full`}
            />
            {/* {formErrors.countryID && (
                              <p className="tw-text-red-600 tw-text-xs">
                                {formErrors.countryID}
                              </p>
                            )} */}
          </div>
          <Button
            label={
              formType === "add"
                ? "Add Statutory Holiday"
                : "Update Statutory Holiday"
            }
            className="tw-flex tw-px-3 tw-py-2 tw-rounded-lg bg-primary border-primary tw-text-white tw-font-medium tw-w-full tw-mt-8"
            onClick={handleAddUpdateHoliday}
            disabled={isAddButtonDisabled}
          />
        </div>
      </Dialog>
    </>
  );
};

export default HolidaysManagement;
